























































































































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import { AuditPackage } from '~/models/audit/package'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import AuditPackageOptionsList from '~/components/shared/classified/audits/AuditPackageOptionsList.vue'
import { capitalizeSentences } from '~/utils/string'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import AuditProviderTerms, {
  PROVIDERS_WITH_TERMS
} from '~/components/shared/classified/audits/terms/AuditProviderTerms.vue'
import AuditPackagePerks from '~/components/shared/classified/audits/AuditPackagePerks.vue'
import CarAuditTerms from '~/components/shared/classified/audits/terms/CarAuditTerms.vue'
import AuditProviderHeader from '~/components/shared/classified/audits/AuditProviderHeader.vue'
import { AuditAvailableProvider } from '~/models/audit/available'
import { defineComponentTranslations } from '~/utils/i18n'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { ciAngleUp } from '~/icons/source/regular/angle-up'
import { useAudits } from '~/compositions/audits'
import CForm from '~/components/shared/configurable/form/CForm.vue'
import { ciAngleLeft } from '~/icons/source/solid/angle-left'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: {
    SpotCheckBadge,
    CarAuditTerms,
    AuditProviderTerms,
    CConfirmationModal,
    AuditPackageOptionsList,
    AuditPackagePerks,
    CPrice,
    AuditProviderHeader,
    CForm
  },
  props: {
    package: {
      type: Object as PropType<AuditPackage>,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    requiresAcceptance: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedShopOption: {
      type: Object as PropType<AuditAvailableProvider>,
      required: true
    }
  },
  setup(props) {
    const { selectedShopOption, package: auditPackage } = toRefs(props)
    const { getUniqueOptions, formatPerks } = useAudits()
    const { t } = useI18n()

    const { getters } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const userIsAdminOrOwner = computed(() => getters('userIsAdminOrOwner'))

    const carTermsAccepted = ref(false)
    const providerTermsAccepted = ref(false)
    const showProviderTermsModal = ref(false)
    const showCarTermsModal = ref(false)
    const isDescriptionExpanded = ref(false)

    const hasOnlyOnePackage = computed(
      () => selectedShopOption.value.packages.length === 1
    )

    const selectedProviderId = computed(
      () => selectedShopOption.value.auditProviderId
    )

    const hasPerks = computed(
      () => auditPackage.value.perks && auditPackage.value.perks.length
    )

    const formatedPerks = computed(() => formatPerks(auditPackage.value.perks))

    const uniqueOptions = computed(() =>
      getUniqueOptions(selectedShopOption.value.packages)
    )

    const showProviderTerms = computed(() =>
      PROVIDERS_WITH_TERMS.includes(selectedProviderId.value)
    )

    const checkoutAlert = computed(() => {
      if (props.package.isInplace) {
        return {
          title: userIsAdminOrOwner.value
            ? t('self_audit_in_place_alert_title')
            : t('audit_in_place_alert_title'),
          description: userIsAdminOrOwner.value
            ? t('self_audit_in_place_alert_description')
            : t('audit_in_place_alert_description')
        }
      }

      return {
        title: userIsAdminOrOwner.value
          ? t('self_audit_alert_title')
          : t('audit_alert_title'),
        description: userIsAdminOrOwner.value
          ? t('self_audit_alert_description')
          : t('audit_alert_description')
      }
    })

    return {
      capitalizeSentences,
      showProviderTerms,
      carTermsAccepted,
      providerTermsAccepted,
      showProviderTermsModal,
      showCarTermsModal,
      isDescriptionExpanded,
      ciAngleDown,
      ciAngleUp,
      uniqueOptions,
      formatedPerks,
      selectedProviderId,
      hasPerks,
      ciAngleLeft,
      checkoutAlert,
      hasOnlyOnePackage
    }
  },

  i18n: defineComponentTranslations({
    self_audit_in_place_alert_title: {
      en: 'The Technical Inspection will take place at your address',
      el: 'Ο Τεχνικός Έλεγχος θα πραγματοποιηθεί στη διεύθυνση σου.'
    },
    self_audit_in_place_alert_description: {
      en:
        'After payment, the provider will contact you to inspect the vehicle.',
      el:
        'Μετά την πληρωμή ο πάροχος θα επικοινωνήσει μαζί σου για τον έλεγχο του οχήματος.'
    },
    audit_in_place_alert_title: {
      en: 'The Technical Inspection will take place at the owner’s address.',
      el: 'Ο Τεχνικός Έλεγχος θα πραγματοποιηθεί στη διεύθυνση του ιδιοκτήτη.'
    },
    audit_in_place_alert_description: {
      en:
        'After payment, the provider will contact the owner to inspect the vehicle.',
      el:
        'Μετά την πληρωμή ο πάροχος θα επικοινωνήσει με τον ιδιοκτήτη για τον έλεγχο του οχήματος.'
    },
    self_audit_alert_title: {
      en: 'The Technical Inspection will take place at the provider’s address.',
      el: 'Ο Τεχνικός Έλεγχος θα πραγματοποιηθεί στη διεύθυνση του παρόχου.'
    },
    self_audit_alert_description: {
      en:
        'After payment, the provider will contact you to inspect the vehicle.',
      el:
        'Μετά την πληρωμή ο πάροχος θα επικοινωνήσει μαζί σου για τον έλεγχο του οχήματος.'
    },
    audit_alert_title: {
      en: 'The Technical Inspection will take place at the provider’s address.',
      el: 'Ο Τεχνικός Έλεγχος θα πραγματοποιηθεί στη διεύθυνση του παρόχου.'
    },
    audit_alert_description: {
      en:
        'After payment, the provider will contact the owner to inspect the vehicle.',
      el:
        'Μετά την πληρωμή ο πάροχος θα επικοινωνήσει με τον ιδιοκτήτη για τον έλεγχο του οχήματος.'
    },
    inspection_address: {
      en: "The Technical Inspection will take place at the provider's address.",
      el: 'Ο Τεχνικός Έλεγχος θα πραγματοποιηθεί στη διεύθυνση του παρόχου.'
    },
    provider_contact_you: {
      en:
        'After payment the provider will contact you for the vehicle inspection.',
      el:
        'Μετά την πληρωμή ο πάροχος θα επικοινωνήσει μαζί σου για τον έλεγχο του οχήματος.'
    },
    payment_after_seller_accepts: {
      en:
        'Payment and inspection will be made after the seller accepts the Technical Inspection request.',
      el:
        'Η πληρωμή και ο έλεγχος πραγματοποιούνται μετά την αποδοχή του αιτήματος Τεχνικού Ελέγχου από τον πωλητή.'
    },
    "provider's terms and conditions::accept": {
      en: "Provider's Terms & Conditions",
      el: 'Όρων & Προϋποθέσεων Παρόχου'
    },
    'car.gr terms and conditions::accept': {
      en: 'Car.gr Terms & Conditions',
      el: 'Όρων & Προϋποθέσεων Car.gr'
    },
    selected_package: {
      en: 'Selected package',
      el: 'Επιλεγμένο πακέτο'
    }
  })
})
